import React from 'react';

import { TitleBooleanField } from '@warehouse/title/ui';
import { titlePaths } from '@warehouse/title/core';

export function ThreeDField() {
	return <TitleBooleanField label="3D" path={titlePaths.threeD} />;
}
